//---------------------
// AI 계약 상담 (alfred, NZSC-3151/3153)
// 내부 코드명은 alfred 지만, 사용자 노출 URL 은 `/consult*` 로 유지한다.
//---------------------
import store from "@/store";

// 소프트오픈 (NZSC-3151). 비대상자가 URL 직접 진입해도 못 들어가게 차단.
// 진입 판정 = ① 로그인 토큰 있음 ② 이메일 로드됨 ③ isAlfredAvailable(테스터 OR 롤아웃 버킷) — 셋 다일 때만 통과.
// 가드는 컴포넌트보다 먼저 도므로, 직접진입·새로고침으로 이메일이 아직 안 떴으면 먼저 로드한 뒤 판정한다
// (토큰만 보고 통과시키지 않고, 이메일 안 떴다고 대상자를 튕기지도 않게).
const guard = async (to, from, next) => {
  // ① 로그인 토큰 없으면 로그인으로 유도(홈 튕김 X). state=consult → 로그인 후 /consult/report-list 복귀.
  //    계약상담 탭은 비로그인한테도 노출되므로, 탭/직접URL 진입 시 로그인 화면으로 보낸다.
  if (!localStorage.naezip_to_ac_se) {
    next("/login?state=consult");
    return;
  }
  // ② 이메일 미로드면 로드 (/api/v1/user/name → _email 채움)
  const email = ((store.state.userStore && store.state.userStore._email) || "").trim();
  if (!email) {
    await store.dispatch("userStore/acUserName");
  }
  // ③ 토큰 + 이메일 로드 + (테스터 OR 롤아웃 버킷) = 대상자일 때만 허용
  if (store.getters["userStore/isAlfredAvailable"]) {
    next();
  } else {
    next("/");
  }
};

// 랜딩(/consult) 전용 가드 — 비로그인도 열람 가능(마케팅/발견용). 오픈 플래그만 확인.
// 로그인은 랜딩의 '맞춤 상담 시작하기'에서 요구(fnStart → /login?state=consult → 로그인 후 report-list).
const landingGuard = (to, from, next) => {
  if (store.getters["userStore/isAlfredTabVisible"]) {
    next();
  } else {
    next("/");
  }
};

const alfredRouter = [
  {
    // GNB 진입점(랜딩). 비로그인도 열람 가능 — '시작하기'에서 로그인 요구.
    // 로그인 + 상담이력 있으면 fnInit이 report-list로 자동 replace.
    path: "/consult",
    name: "consult",
    component: () => import("../views/alfred/AlfredLandingView.vue"),
    beforeEnter: landingGuard,
  },
  {
    // 발급 리포트 목록 (0건: 신청 퍼널 유도 / N건: 상담에 쓸 리포트 선택)
    path: "/consult/report-list",
    name: "consult-report-list",
    component: () => import("../views/alfred/AlfredReportListView.vue"),
    beforeEnter: guard,
  },
  {
    // 상담 채팅 (첫화면 + 멀티턴). ?session=<sessionSeq> 로 기존 세션 진입.
    path: "/consult/chat",
    name: "consult-chat",
    component: () => import("../views/alfred/AlfredChatView.vue"),
    beforeEnter: guard,
  },
  {
    // 충전 (이용한도 초과). 주문생성(POST /api/v1/alfred/order) → PG 결제 → 백엔드 웹훅 확정.
    path: "/consult/charge",
    name: "consult-charge",
    component: () => import("../views/alfred/AlfredChargeView.vue"),
    beforeEnter: guard,
  },
  {
    // 서울시 무료 리포트 유저 추가결제 진입. 주문생성 → PG 결제 → 백엔드 웹훅 확정.
    path: "/consult/seoul-pay",
    name: "consult-seoul-pay",
    component: () => import("../views/alfred/AlfredSeoulPayView.vue"),
    beforeEnter: guard,
  },
];

export default alfredRouter;
